import CryptoJS from 'crypto-js'
import CookiesUtils from '@/common/utils/CookiesUtils'

/**
 * 0: 本地环境
 * 1: 开发环境
 * 2: 测试环境
 * 3: 正式环境
 */
enum ConfigEnv {
  LOCAL_DEVELOPED = 0,
  DEVELOPED,
  TEST,
  PRODUCT
}
class Config {
  private verStr = MY_Version
  private apiUrl = ''
  private fileUploadUrl = ''
  private baseUrl = '/'
  private apiType = ''
  private envType: ConfigEnv
  constructor() {
    this.envType = MY_ENV
    this.apiType = 'java'
    this.setApiUrl()
  }
  public getVersion() {
    return this.verStr
  }

  public getApiUrl() {
    return this.apiUrl
  }

  public getFileUploadUrl() {
    return this.fileUploadUrl
  }

  public getShowMenuLogo() {
    return true
  }

  public getApiKey() {
    return '1717089693594230785'
  }

  public getApiType() {
    return this.apiType
  }

  public getBaseUrl() {
    return this.baseUrl
  }

  public getWechatBaseApi() {
    const url =
      this.envType === ConfigEnv.PRODUCT
        ? 'https://ticket.sjht.com:8075/wechat/qrcode?appId=ae3673c77f79adf7a1f1c4601c512557'
        : 'https://ticket.sjht.com:8075/wechat/qrcode?appId=a6bbd03c3c49b78a057eaa03f0aaf973'
    return url
  }

  public rsaPublicKey() {
    return 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCeNS0RwGxx6fLYTZiiyWuxsyS50H7/iC4Nm1ogfE2Iho/R5pe3cORa7hl7eSOBdCVo/AkD+Cr/Hdt7Ocq7voMW+3/PQsJe3pcijxicYJdMnY0PF4UPKQHZSA5ZRFtUfrPotZlnVjS/42HbPJCotOb7rf7JFk3tjDtwMuI4Vs8BVwIDAQAB'
  }

  private setApiUrl() {
    if (this.envType === ConfigEnv.LOCAL_DEVELOPED) {
      this.apiUrl = 'http://127.0.0.1:8072'
      this.fileUploadUrl = this.apiUrl + '/public/system/fileMgr/updateFile'
    } else if (this.envType === ConfigEnv.DEVELOPED) {
      this.apiUrl = 'https://etctest.cyzl.com/broad-channel-gateway/manage'
      this.fileUploadUrl = this.apiUrl + '/public/system/fileMgr/updateFile'
    } else if (this.envType === ConfigEnv.TEST) {
      this.apiUrl = 'https://etctest.cyzl.com/broad-channel-gateway/manage'
      this.fileUploadUrl = this.apiUrl + '/public/system/fileMgr/updateFile'
    } else if (this.envType === ConfigEnv.PRODUCT) {
      // this.apiUrl = 'http://43.136.68.109:31230/broad-channel-gateway/manage'
      this.apiUrl = 'https://yhg.dianxiaobao88.com/broad-channel-gateway/manage'
      // this.apiUrl = 'https://fqd.cyzl.com/broad-channel-gateway/manage'
      this.fileUploadUrl = this.apiUrl + '/public/system/fileMgr/updateFile'
    }
  }

  public getSign(data: any, nowTime: string) {
    let content = JSON.stringify(data)
    // console.log(content)
    content = content
      .split('')
      .sort()
      .join('')
    content = this.verStr + nowTime + content
    let newStr = ''
    for (let i = 0; i < content.length; i++) {
      if (
        content.charAt(i) == ' ' ||
        content.charAt(i) == '\r' ||
        content.charAt(i) == '\n' ||
        content.charAt(i) == '\t'
      ) {
        continue
      }
      newStr += content.charAt(i)
    }
    content = newStr
    const ret = CryptoJS.MD5(content)
      .toString()
      .toLowerCase()
    // console.log(ret)
    return ret
  }
}

// const ProConfig: Config = new Config(ConfigEnv.PRODUCT)
// const ProConfig: Config = new Config(ConfigEnv.TEST)
// const ProConfig: Config = new Config(ConfigEnv.LOCAL_DEVELOPED)
const ProConfig: Config = new Config()

export default ProConfig
